module.exports = __webpack_public_path__ + "media/images/icons/followers-ac7c495c5ecbaf8bc5b01c7b130609df.svg";